import { useMemo } from "react";

import { ModuleStatus } from "src/clients/flow-api";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useIsAgentsEnabled = (): {
  isEnabled: boolean;
} => {
  const { modules } = useWorkspaceContext();

  const isEnabled = useMemo(() => {
    if (!modules?.agents) {
      return false;
    }

    const agentsModule = modules.agents;
    return (
      agentsModule.status !== ModuleStatus.CREATE_IN_PROGRESS &&
      agentsModule.status !== ModuleStatus.CREATE_FAILED
    );
  }, [modules]);

  return {
    isEnabled,
  };
};
